import { createAsyncThunk } from '@reduxjs/toolkit';
import { News } from '../../../model';
import newsRepository from '../../../repositories/news/news-repository';
import { AsyncThunkConfig } from '../../async-thunk-config';
import { NewsDownloadError } from './news-types';

export const downloadNewsList = createAsyncThunk<
  News[],
  void,
  AsyncThunkConfig<NewsDownloadError>
>('download-offer-documents', async (_, thunkApi) => {
  try {
    return await newsRepository.getNewsList(thunkApi);
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});
